import { queryOptions } from '@tanstack/react-query'
import { SearchSearchParams } from '@/search-params-parser/search'
import { searchProducts } from '@/actions/search/search-products'
import { getSmartPickKeywords } from '@/actions/smart-picks/get-smart-pick-keywords'
import { getSmartPickProducts } from '@/actions/smart-picks/get-smart-pick-products'
import { getAutoCompletes } from '@/actions/search/get-auto-completes'
import { searchUrl } from '@/actions/search/search-url'

export const searchQuery = {
  query: (params: SearchSearchParams) =>
    queryOptions({
      queryKey: ['search', { ...params }],
      queryFn: async () => {
        const res = await searchProducts(params)
        if (res.type === 'error') {
          throw new Error(res.error)
        }
        return res.data
      },
      enabled: !!params.q,
    }),

  recommendedKeywords: () => {
    return queryOptions({
      queryKey: ['search', 'recommendedKeywords'],
      queryFn: async () => {
        const res = await getSmartPickKeywords()
        if (res.type === 'error') {
          throw new Error(res.error)
        }
        return res.data
      },
    })
  },

  recommendedProducts: () => {
    return queryOptions({
      queryKey: ['search', 'recommendedProducts'],
      queryFn: async () => {
        const res = await getSmartPickProducts()
        if (res.type === 'error') {
          throw new Error(res.error)
        }
        return res.data
      },
    })
  },

  autoCompletes: (term: string) => {
    return queryOptions({
      queryKey: ['search', 'autoCompletes', term],
      queryFn: async () => {
        const res = await getAutoCompletes(term)
        if (res.type === 'error') {
          throw new Error(res.error)
        }
        return res.data
      },
      enabled: !!term,
    })
  },

  link: (url: string) => {
    return queryOptions({
      queryKey: ['search', 'link', url],
      queryFn: async () => {
        const res = await searchUrl(url)
        if (res.type === 'error') {
          throw new Error(res.error)
        }
        return {
          ...res.data,
          statusCode: res.statusCode,
          retry: res.statusCode === 202,
        }
      },
      refetchInterval: (query) => {
        if (query.state.data?.retry) {
          return 1000
        }
        return false
      },
      enabled: !!url,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    })
  },
}
